import React from 'react'

export default function ArrowLeftIcon(){
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.5 17L9.5 12L14.5 7" stroke="#202026" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    )
}
